<template lang="pug">
  .getting-started
    p User our Quick Start tour to learn more about the features and capabilities of this application.
    v-btn(
      block
      class="black--text"
      color="secondary"
      slot="activator"
      @click="startTour")
      v-icon(left) directions
      | TAKE A TOUR
</template>

<script>
import { eventBus } from '@/services/utils'

export default {
  methods: {
    startTour () {
      if (localStorage.DoNotShowAgain) {
        localStorage.removeItem('DoNotShowAgain')
      }
      eventBus.$emit('start-tour')
    }
  }
}
</script>

<style lang="stylus" scoped>
  .getting-started
    padding 1em
    .btn.theme--light.secondary
      margin-left 0
</style>
